import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as mm from 'moment-timezone';


@Injectable({
  providedIn: 'root'
})
export class UVRChartDataExcelService {

  constructor() { }
  // formatDate(date:Date){
  //   return moment(date).format('YYYY/MM/DD')+'';
  // }  
  // formatPart(partNo:string){
  //   if (partNo.length !== 12) {
  //     return 'Part No. must be exactly 12 characters long'
  //   }

  //   const part1 = partNo.slice(0, 5);
  //   const part2 = partNo.slice(5, 10);
  //   const part3 = partNo.slice(10, 12);

  //   return `${part1}-${part2}-${part3}`;
  // }
  generateExcel(data: any, base64Image, dock) {
    // console.log('excel data', data);
    var processed_data: any = [];
    // {
    //   apccapacity: ""
    //   business_entity: "02"
    //   container_renban: "E2453"
    //   delivery: "0.00" - No of lots
    //   lineoff_date : "2025-03-26 00:00:00"
    //   max :  ""
    //   min : ""
    //   stocking_date : "20250326 E2453"
    //   yearWeekMonDateCR : data
    //   usage: "84.58" - no of peaces
    //   usage_v_receipt : "-0.04"
    //   uvr_by_day_req : "84.58" - by days
    //   yearweek : "202513"
    //   uvr:// selected option chart for
    //   forcast // if not UVR
    // }
    data.forEach((element: any, index: number) => {
      if (!element.hasOwnProperty('addtoexcel')) {
        var e: any = {
          stockingDate: element.stocking_date ? element.stocking_date : 0,
          value: element.uvrCumulInBoxes,
          // yearWeekMonDateCR: element.yearWeekMonDateCR ? element.yearWeekMonDateCR : 0,
          // apccapacity: element.apc ? element.apc : 0,
          containerRenban: element.container_renban ? element.container_renban : 0,
          delivery: isNaN(Number(element.delivery)) ? 0 : Number(element.delivery),
          //lineoffDate : element.lineoff_date?element.lineoff_date:0,
          max: isNaN(Number(element.maxStock)) ? 0 : Number(element.maxStock),
          min: isNaN(Number(element.minStock)) ? 0 : Number(element.minStock),
          usage: isNaN(Number(element.usage)) ? 0 : Number(element.usage),
          usageVReceipt: element.usage_v_receipt ? element.usage_v_receipt : 0,
          uvrByDayReq: element.uvr_by_day_req ? element.uvr_by_day_req : 0,
          // yearweek : element.yearweek?element.yearweek:0,
          uvr: element.uvr ? element.uvr : 0,
          forcast: element.forcast ? element.forcast : 0,
          uveinPeaces: element.uvrCumulInPieces,
        };
        processed_data.push(e);
      }else{
        console.log("entry skipped");
      }
    });

    this.getData(processed_data, base64Image, dock).catch((err) => console.error(err));
  }
 easternCurrentDate = String(mm().tz('US/Michigan').format('YYYY-MM-DD_HH:mm:ss'));

   timestamp = this.easternCurrentDate
  .split('.')[0]
  .replace('T', '_')
  .split('')
  .filter((d) => d !== '-' && d !== ':')
  .join('');

  async getData(data: any, base64Image, dock) {
    const easternCurrentDate2 = String(mm().tz('US/Michigan').format('YYYY-MM-DD_HH:mm:ss'));

    const timestamp2 = easternCurrentDate2
   .split('.')[0]
   .replace('T', '_')
   .split('')
   .filter((d) => d !== '-' && d !== ':')
   .join('');
 
    const workbook: ExcelJS.Workbook = new ExcelJS.Workbook();
    // monkeyPatchPivotTable();
    await this.insertDataintoSheet(workbook, data);
    await this.createChart(workbook, data, base64Image);
    // await this.createPivot(workbook, data);

    // Generate the Excel file as a buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Create a Blob from the buffer and trigger a download
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    // saveAs(blob, 'Excelize.xlsx');
    saveAs(blob, `UvR_${dock}_${timestamp2}.xlsx`);
  }
  createChart = async (workbook: ExcelJS.Workbook, data, base64Image) => {
    const worksheet = workbook.addWorksheet('Chart');
    // Add the base64 image to the workbook
    const imageId = workbook.addImage({
      // base64: "data:image/png;base64,<your_base64_string_here>", // Replace <your_base64_string_here> with the actual base64 data
      base64: base64Image,
      extension: 'png', // Specify the image format (e.g., 'png', 'jpeg')
    });

    // Define where to place the image in the worksheet
    worksheet.addImage(imageId, {
      tl: { col: 1, row: 1 }, // Top-left corner (column and row)
      ext: { width: 1500, height: 600 }, // Width and height of the image
    });
    // worksheet.properties.default = true;
  }
  createPivot = async (workbook: ExcelJS.Workbook, data) => {
    const worksheet = workbook.addWorksheet('Pivot');

    // const worksheet = workbook.addWorksheet('My Sheet');
    worksheet.addRow(['Stocking date', 'value', 'min', 'max']);
    let UpdatedData = []
    data.forEach((element: any, index: number) => {
      UpdatedData.push([element.stockingDate, element.value, element.min, element.max]);
    });
    worksheet.addRows(UpdatedData);
    worksheet.addTable({
      name: 'MyTable',
      displayName: "UVR DATA",
      ref: 'A1',
      headerRow: true,
      totalsRow: true,
      style: {
        theme: 'TableStyleMedium2',
        showRowStripes: true,
        showFirstColumn: true,
      },
      columns: [
        { name: 'Stocking date' },
        { name: 'Value', totalsRowFunction: 'sum', totalsRowLabel: 'Grand Total' },
        { name: 'Min', totalsRowFunction: 'sum', totalsRowLabel: 'Grand Total' },
        { name: 'Max', totalsRowFunction: 'sum', totalsRowLabel: 'Grand Total' },
      ],
      rows: UpdatedData
    });

  }
  insertDataintoSheet = async (workbook: ExcelJS.Workbook, data) => {
    const worksheet = workbook.addWorksheet('Data');

    // Set the zoom level to 75%
    worksheet.views = [{ state: 'normal', zoomScale: 100 }];
    // row 1
    // Define columns for the worksheet
    worksheet.columns = [
      { header: 'Stocking Date', key: 'stockingDate', width: 20, font: { bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Value', key: 'value', font: { bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Min', key: 'min', font: { bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Max', key: 'max', font: { bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Usage', key: 'usage', font: { bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false }, style: { numFmt: '0.00' } },
      { header: 'Delivery', key: 'delivery', font: { bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false }, style: { numFmt: '0.00' } },
      { header: 'UVR (pcs)', key: 'uveinPeaces', font: { bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
    ];
    data.forEach((element: any, index: number) => {
      worksheet.addRow(element);
    });
    worksheet.eachRow((row) => {
      row.eachCell((cell, index) => {
        if (cell.value !== null && cell.value !== undefined) {
          if (index == 0)
            cell.font = { name: 'Arial', family: 2, size: 12, bold: true };
          else
            cell.font = { name: 'Arial', family: 2, size: 10 };
          cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: false };
          if (cell.value == 0) cell.value = 0;
        }
      });
    });
  }
}
